import { ThemeProvider, createTheme } from '@mui/material';
import './App.css';
import LocationWeatherProvider from './contexts/LocationWeatherContext';
import Main from './pages/Main';
import { DAY_NIGHT_TEXT_COLOR } from './types/Weather';

function App() {

  const theme = createTheme({
    components: {
      // Search places Text Field
      MuiTextField: {
        styleOverrides: {
          root: {
            '& label.Mui-focused': {
              color: DAY_NIGHT_TEXT_COLOR,
            },
            '& .MuiInput-underline:after': {
              borderBottomColor: DAY_NIGHT_TEXT_COLOR,
            },
            '& .MuiInputLabel-root': {
              color: DAY_NIGHT_TEXT_COLOR,
            },
            '& .MuiOutlinedInput-input': {
              color: DAY_NIGHT_TEXT_COLOR,
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: DAY_NIGHT_TEXT_COLOR,
              },
              '&:hover fieldset': {
                borderColor: DAY_NIGHT_TEXT_COLOR,
              },
              '&.Mui-focused fieldset': {
                borderColor: DAY_NIGHT_TEXT_COLOR,
              },
            },
            '& .MuiSvgIcon-root': {
              color: DAY_NIGHT_TEXT_COLOR,
            }
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: DAY_NIGHT_TEXT_COLOR,
          },
        }
      }
    },
  });

  return (
    <LocationWeatherProvider>
      <ThemeProvider theme={theme}>
        <Main />
      </ThemeProvider>
    </LocationWeatherProvider>
  );
}

export default App;
